import { z } from "zod"
import errorMap from "./validation-error-map"

// Normalised email validation that transforms to lowercase and removes spaces
export const normalisedEmailValidation = z.string({ errorMap }).min(1).email().transform(val => val.toLowerCase().replace(/\s/g, ''))

export const ValidEmailSchema = z.object({
   email: normalisedEmailValidation
})
